import api from '../../api/v2/api'
import SchoolSetting from '../../api/v2/models/school_setting'

class HeaderState {
  schoolSetting: SchoolSetting | null = null
  customTexts: Map<string, string> = new Map()
  headerTitle: string = ""

  async getSchoolSetting() {
    try {
      const schoolSetting = await api.schoolSetting.get()
      this.schoolSetting = schoolSetting
      this.changeDocumentTitle()
      this.getCustomText()
    } catch (e) {}
  }

  async getCustomText() {
    try {
      const customTexts = await api.customText.index()
      var customTextsMap = new Map<string, string>()
      customTexts.forEach((customText) => {
        customTextsMap.set(customText.category + "." + customText.key, customText.text)
      })
      this.customTexts = customTextsMap
    } catch (e) {}
  }


  setTitle(title: string) {
    this.headerTitle = title
    this.changeDocumentTitle()
  }

  private changeDocumentTitle(){
    if (this.schoolSetting) {
      document.title = `${this.headerTitle} | ${this.schoolSetting.name}`
    }
  }
}

export const headerState = new HeaderState()
